import { ExportDestinationsMap, PipelineEventType, PipelineExporterQuery, } from "@supernova-studio/model";
import { DTOExporterPropertyValueMap } from "./exporter-property";
import { DTOExportJob } from "./job";
import { z } from "zod";
export const DTOPipelineExporterQuery = PipelineExporterQuery;
export const DTODesignSystemPipelineListQuery = DTOPipelineExporterQuery.extend({
    latestJobsLimit: z.coerce.number().optional(),
});
export const DTOPipelineListQuery = z.object({
    designSystemId: z.string().optional(),
    exporterId: z.string().optional(),
    latestJobsLimit: z.coerce.number().optional(),
});
export const DTOPipeline = z.object({
    id: z.string(),
    name: z.string(),
    eventType: PipelineEventType,
    isEnabled: z.boolean(),
    workspaceId: z.string(),
    designSystemId: z.string(),
    exporterId: z.string(),
    brandPersistentId: z.string().optional(),
    themePersistentId: z.string().optional(),
    themePersistentIds: z.string().array().optional(),
    contextIds: z.string().array().optional(),
    exporterPropertyValues: DTOExporterPropertyValueMap.optional(),
    ...ExportDestinationsMap.shape,
    latestJobs: DTOExportJob.array(),
    isExporterDeprecated: z.boolean(),
});
export const DTOPipelineListResponse = z.object({
    pipelines: DTOPipeline.array(),
});
export const DTOPipelineResponse = z.object({
    pipeline: DTOPipeline,
});
export const DTOWorkspaceStats = z.object({
    pipelines: z.object({
        totalCount: z.number(),
    }),
});
